export default {"src":"/_next/static/media/shareLIGrey.8bb67d67.svg","height":32,"width":32};